import { Button, Flex, Text, useToast } from '@chakra-ui/react';
import { FC, PropsWithChildren, useEffect } from 'react';

interface UpdateEvent {
  newVersionAvailable: boolean;
  timestamp: number;
  message: string;
}

export const ClientUpdateNotification: FC<PropsWithChildren> = ({
  children,
}) => {
  const toast = useToast();

  useEffect(() => {
    let eventSource: EventSource;

    if (window.ENVS.environment === 'e2e') {
      return;
    }

    try {
      eventSource = new EventSource('/client-message/sse/client-update', {
        withCredentials: false,
      });

      eventSource.onopen = () => {
        // eslint-disable-next-line no-console
        console.log('SSE connection established');
      };

      eventSource.onmessage = (event) => {
        const data: UpdateEvent = JSON.parse(
          event.data as string
        ) as UpdateEvent;
        if (data.newVersionAvailable) {
          toast({
            title: 'New version available',
            description: (
              <Flex alignItems="center" gap={2} justifyContent="space-between">
                <Text>{data.message || 'Please refresh your browser'}</Text>
                <Button
                  bg="indigo.900"
                  color="white"
                  size="xs"
                  onClick={() => window.location.reload()}
                >
                  Refresh
                </Button>
              </Flex>
            ),

            status: 'info',
            duration: null,
            isClosable: true,
          });
        }
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to create EventSource:', error);
    }

    return () => {
      if (eventSource) {
        eventSource.close();
      }
    };
  }, [toast]);

  return children;
};
